import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { SettlementData } from "./SettlementData";

const Settlement = () => {
  document.title = "Settlement Details| mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Settlement Details" />
          <SettlementData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Settlement;
